import isEqual from "lodash/isEqual";
import uniq from "lodash/uniq";
import without from "lodash/without";
import React, { useState } from 'react';
import useClickPast from "../../hooks/useClickPast";
import useFilter from '../../hooks/useFilter';
import Button from "../core/Button";
import Checkbox from "../core/Checkbox";
import Dropdown from "../core/Dropdown";
import EmptyTable from '../core/EmptyTable';
import Table from "../core/Table";
import Preloader from "../Preloader";
import EmployeesFilterForm from '../Public/markup/EmployeesFilterForm';
import { MenuNavPeoplesIcon, SfFilterMenuIcon, CabinetTreeActionEditIcon, CabinetTreeActionAddIcon, CabinetTreeActionDeleteIcon, SfFilterCopyIcon } from "../Public/markup/icons";
import './style.scss';
import request from "../../api";
import { standartErrorToast, standartSuccessToast } from "../toasts";
import SubmitButton from "../SubmitButton";
import useObjectState from "../../hooks/useObjectState";
import useApi from "../../hooks/useApi";
import { toFormData } from "../../utils";
import LoadMoreSpinner from "../LoadMoreSpinner";
import useModalWithData from "../../hooks/useModalWithData";
import { SubdivisionModal, UserInfoModal } from "../../pages/Tree";
import PanModal from "../core/PanModal";
import Modal from "../core/Modal";
import useCompanyRole from "../../hooks/useCompanyRole";
import FixationTableFilterForm from "../Public/markup/FixationTableFilterForm";
import { CrmFilterBottomRow } from "../../pages/Crm/CrmFilter";
import { fixationsBottomFilters } from "../../pages/Crm/utils";
import usePermission from "../../hooks/usePermission";
import FixationsNew from "../../pages/Fixations/fixationsNew";
import { useModal } from "react-modal-hook";
import PersonalCabinet from "../../pages/PersonalCabinet";
import { ShowMore } from "../core/Table2";


const FixationsTable = () => {
  const {
    handleFilter,
    isLoading,
    filter,
    data: {
      filters: filterData = {},
      deals = [],
      access_list = [],
      access_edit_departament,
      full_acess_company,
      full_acess_department,
      user_departament,
      count,
      countDeals,
    },
    setFilterAndExclude,
    filterBadges,
    removeBadge,
    resetFilter,

    dataSetter,
    handleLoadMore,
    moreIsLoading,
    customLoadMore
  } = useFilter({
    apiConfig: {
      component: 'panpartner:deals.ajax',
      submitFunction: 'getFixationList',
    },
    defaultFilter: {
    },
    defaultParams: {
    },
    shadowFilters: ['status'],
    fields: {
      parkingType: [],
      prices: {},
      status: [],
      features: []
    },
    defaultPage: 0,
    loadMoreDataKey: "deals",
    refreshWhenFilterChange: true,
    processData: (resp, prev) => {
      if (prev.filter) delete resp.filter;
      return { ...prev, ...resp };
    },
    beforeRefresh: (form) => {
      form.delete("isGetFilter")
    },
    paginationEnabled: true
  });


  const columns = [

    {
      title: "Клиент",
      dataIndex: "client",
      render: (client, { clientPhone, clientEmail, isEndFixation }) => <>
        {<p style={isEndFixation ? {color: '#ff2d23'} : {}} className={`h6`}>{client}</p>}
        {<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{clientPhone}</p>}
        {<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{clientEmail}</p>}
      </>
    },
    {
      title: "Застройщик",
      dataIndex: "builder",
      render: (builder, {isEndFixation}) => <>{<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{builder}</p>}</>
    },
    {
      title: "Жк",
      dataIndex: "block",
      render: (block, {isEndFixation}) => <>{<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{block}</p>}</>
    },
    {
      title: "Добавлен",
      dataIndex: "dateCreate",
      render: (dateCreate, {isEndFixation}) => <>{<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{dateCreate}</p>}</>
    },
    {
      title: "Фиксация до",
      dataIndex: "dateFixationTo",
      render: (dateFixationTo, {isEndFixation}) => <>{<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{dateFixationTo}</p>}</>
    },
    {
      title: "Агент",
      dataIndex: "agent",
      render: (agent, {isEndFixation}) => <>{<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{agent}</p>}</>
    },
    {
      title: "Статус",
      dataIndex: "status",
      render: (status, {isEndFixation}) => <>{<p style={isEndFixation ? {color: '#ff2d23'} : {}}>{status}</p>}</>
    },

  ]
  const isNotAgent = usePermission("not-agent")

  const [openFixationModal, closeFixationtModal] = useModal(
    () => (
      <PanModal title={'Фиксация клиента'} isBig closeModal={closeFixationtModal}>
        <FixationsNew closeFixationtModal={closeFixationtModal} />
      </PanModal>
    ),
    [],
  );
  if (isLoading) return <Preloader loading />;


  return (
    <div className="wrapper">
      <PersonalCabinet />
      <h3 className="h3 sf__h1 with-tg-link" style={{ marginBottom: 11 }}>
        <p>Фиксации</p>
      </h3>
      <div className="company-employers crm-table crm-table_filters">
        <div className="crm-filters-header__first-row" style={{ position: 'relative' }}>
          <div className="crm-filters-header__left-cell">
            <FixationTableFilterForm
              filterData={filterData}
              filter={filter}
              setFilterAndExclude={setFilterAndExclude}
              handleFilter={handleFilter}
              isLoading={isLoading}
            />
          </div>
          <div className="crm-filters-header__right-cell" style={{ paddingTop: 30 }}>
            <Button onClick={resetFilter} buttonType="secondary" type="button">Сбросить</Button>
          </div>
          <div className="crm-filters-header__right-cell" style={{ paddingTop: 30 }}>
            <Button onClick={openFixationModal} buttonType="primary" type="button">Зафиксировать</Button>
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          {filterData && <CrmFilterBottomRow
            filters={fixationsBottomFilters}
            setFilter={(key, value) => handleFilter(key, value ? 1 : 0)}
            filter={filter}
            permissions={{ "not-agent": isNotAgent }}
            style={{marginTop: 0}}
          />}
        </div>
        <div style={{ marginBottom: 10, display: "flex"}}>
          <p className={`h6`}>Количество:&nbsp;</p>{count}
        </div>

        <Table
          rowKey="id"
          showSorterTooltip={false}
          columns={columns}
          dataSource={deals}
          pagination={false}
          locale={{ emptyText: "ничего не найдено" }}
          customPagination={false}
        />
        {count > deals?.length && <ShowMore onClick={()=>customLoadMore(deals.at(-1)?.id)} loading={moreIsLoading} />}
      </div>
    </div>
  )
}

export default FixationsTable;
